<template>
  <div class="oldmanmap">
    <div id="cane-container" class="map" ref="amap"></div>
    <div class="realData">
      <!-- 标题 -->
      <div class="realTitle">
        <i class="el-icon-s-opportunity" style="color:#ee6666;font-size:24px;margin-right:8px"></i>
        <span>{{ deviceNo }} 拐杖数据</span>
      </div>

      <!-- 实时状态 -->
      <div class="center">
        <p class="section-title">设备状态</p>

        <div class="data-row" style="color:#409EFF">
          <span>ICCID</span>
          <span>{{ statusData.iccid || '—' }}</span>
        </div>
        <div class="data-row" :style="{ color: batteryColor }">
          <span>电量</span>
          <span>
            {{ statusData.batteryLevel != null ? statusData.batteryLevel + '%' : '—' }}
            <i v-if="statusData.batteryLevel != null && statusData.batteryLevel <= 20"
               class="el-icon-warning" style="color:red;margin-left:4px"></i>
          </span>
        </div>
        <div class="data-row" style="color:#67C23A">
          <span>信号强度</span>
          <span>{{ statusData.signalStrength != null ? statusData.signalStrength : '—' }}</span>
        </div>
        <div class="data-row" style="color:#909399">
          <span>固件版本</span>
          <span>{{ statusData.version != null ? 'V' + statusData.version : '—' }}</span>
        </div>
      </div>

      <!-- 最近位置 -->
      <div class="center" style="border-top:1px solid #e1e3e9">
        <p class="section-title">最近位置</p>
        <div class="data-row" style="color:#E6A23C">
          <span>纬度</span>
          <span>{{ statusData.lastLatitude || '—' }}</span>
        </div>
        <div class="data-row" style="color:#E6A23C">
          <span>经度</span>
          <span>{{ statusData.lastLongitude || '—' }}</span>
        </div>
        <div class="data-row" style="color:#909399">
          <span>更新时间</span>
          <span style="font-size:11px">{{ statusData.updateTime || '—' }}</span>
        </div>
      </div>

      <!-- 快捷指令 -->
      <div class="list">
        <p class="section-title">快捷指令</p>
        <el-button size="mini" type="primary" plain style="width:100%;margin-bottom:6px"
          :loading="cmdLoading.findDevice" @click="sendCmd('findDevice')">
          查找设备（响铃）
        </el-button>
        <el-button size="mini" type="warning" plain style="width:100%;margin-bottom:6px"
          :loading="cmdLoading.manualLoc" @click="sendCmd('manualLoc')">
          手动触发定位
        </el-button>
        <el-button size="mini" type="danger" plain style="width:100%"
          :loading="cmdLoading.reboot" @click="sendCmd('reboot')">
          重启设备
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
import AMapLoader from '@amap/amap-jsapi-loader';

export default {
  data() {
    return {
      deviceNo: "",
      deviceId: "",
      AMap: null,
      map: null,
      statusData: {},
      cmdLoading: {
        findDevice: false,
        manualLoc: false,
        reboot: false,
      },
    };
  },
  computed: {
    batteryColor() {
      const b = this.statusData.batteryLevel;
      if (b == null) return "#909399";
      if (b <= 20) return "#F56C6C";
      if (b <= 50) return "#E6A23C";
      return "#67C23A";
    },
  },
  methods: {
    initAMap() {
      AMapLoader.load({
        key: 'bb369d6617c417b4826cee55ac7ad116',
        version: '2.0',
        plugins: [],
      }).then((AMap) => {
        this.AMap = AMap;
      }).catch((e) => {
        console.error('AMap load error', e);
      });
    },

    getCaneData() {
      this.$postForm(`dmc/cane/data/${this.deviceNo}`).then((res) => {
        if (res.code == 200 && res.result) {
          this.statusData = res.result;
          // 如果有 GPS，在地图上打点
          if (res.result.lastLatitude && res.result.lastLongitude && this.AMap) {
            this.showOnMap(
              parseFloat(res.result.lastLongitude),
              parseFloat(res.result.lastLatitude)
            );
          }
        }
      }).catch(() => {});
    },

    getLocation() {
      // 优先使用 watch 的实时定位接口（复用已有基础设施）
      this.$postForm(`dmc/watch/queryRealLocationByDeviceId/${this.deviceId}`).then((res) => {
        if (res.result && res.result.gpsString) {
          const gpsArr = res.result.gpsString.split(',').map(s =>
            s.trim().replace(/[\u200B-\u200F\uFEFF\s]/g, '').replace(/[^0-9.]/g, '')
          );
          const lng = parseFloat(gpsArr[0]);
          const lat = parseFloat(gpsArr[1]);
          if (!isNaN(lng) && !isNaN(lat) && this.AMap) {
            this.showOnMap(lng + 0.0055, lat - 0.0025, res.result.location);
          }
        } else {
          // 回退：用 cn_dmc_cane_data 中存储的最近 GPS
          this.showDefaultMap();
        }
      }).catch(() => { this.showDefaultMap(); });
    },

    showOnMap(lng, lat, label) {
      const AMap = this.AMap;
      if (!AMap) return;
      const map = new AMap.Map('cane-container', {
        zoom: 17,
        zooms: [5, 30],
        center: [lng, lat],
      });
      this.map = map;
      const content = `<div class="amap-maker-icon"><div class="title">${label || this.deviceNo}</div></div>`;
      map.add(new AMap.Marker({ position: [lng, lat], content }));
    },

    showDefaultMap() {
      if (!this.AMap) return;
      const map = new this.AMap.Map('cane-container', {
        zoom: 12,
        zooms: [5, 30],
        center: [114.4013, 30.449],
      });
      this.map = map;
    },

    sendCmd(type) {
      this.cmdLoading[type] = true;
      this.$postJson(`dmc/cane/command/${type}/${this.deviceNo}`, {})
        .then((res) => {
          this.cmdLoading[type] = false;
          this.$message({ type: res.code == 200 ? 'success' : 'error', message: res.message });
        })
        .catch(() => { this.cmdLoading[type] = false; });
    },
  },
  mounted() {
    this.deviceNo = this.$route.query.deviceNo;
    this.deviceId = this.$route.query.deviceId;
    this.initAMap();
    this.getCaneData();
    // 等 AMap 加载完成后再渲染地图
    setTimeout(() => { this.getLocation(); }, 800);
  },
};
</script>

<style lang="scss" scoped>
.oldmanmap {
  margin: 5px;
  border: 1px solid rgb(228, 222, 222);
  .map {
    width: 100%;
    height: 87vh;
  }
}

.realData {
  position: absolute;
  z-index: 999;
  width: 17%;
  margin-left: 78%;
  margin-top: -75vh;
  border: 1px solid #e1e3e9;
  box-sizing: border-box;
  background: #fff;

  .realTitle {
    height: 50px;
    background-color: #fafafa;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #e1e3e9;
    span { color: #494949; font-size: 16px; }
  }

  .section-title {
    font-size: 14px;
    font-weight: 600;
    color: #303133;
    margin: 8px 0 6px;
  }

  .center {
    padding: 10px;
    background-color: #fafafa;
  }

  .data-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    font-size: 13px;
    border-bottom: 1px dashed #f0f0f0;
    &:last-child { border-bottom: none; }
  }

  .list {
    padding: 10px;
    background: #fff;
    border-top: 1px solid #e1e3e9;
  }
}

::v-deep #cane-container {
  height: 87vh;
  width: 100%;

  .amap-maker-icon {
    position: relative;
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background: #409EFF;
    border: 2px solid #fff;
    box-shadow: 0 0 4px rgba(0,0,0,.3);

    .title {
      position: absolute;
      top: -22px;
      left: -70px;
      width: 150px;
      text-align: center;
      color: #333;
      font-size: 13px;
      border-radius: 4px;
      background: rgba(255,255,255,.9);
      padding: 2px 6px;
    }
  }
}
</style>
